import { Modal } from 'components/modal'
import { AddServiceProp, QuoteServicesProps } from 'features/quote/components/type'
import { useEffect, useState } from 'react'
import { Stages } from 'utils/enum'
import PolicyCoveragePlan from './ChangePolicy/PolicyCoveragePlan'
import { ServicesForm } from './ChangePolicy/ServicesForm'
import PolicyPlanSelection from './ChangePolicy/PolicyPlanSelection'
import PolicyQuoteReview from './ChangePolicy/PolicyQuoteReview'
import { ModalEnum } from 'features/incidents/components/enums'
import StripeComponent from 'features/stripe/page/StripeComponent'
import { ChangePolicyPayment } from 'features/stripe/components/ChangePolicyPayment'
import UserAnnualRevenue from './ChangePolicy/UserAnnualRevenue'

const ChangePolicy = (props: AddServiceProp) => {
  const { openModal, setOpenModal, setNotification, planId } = props

  const [stage, setStage] = useState<Stages>(Stages.STAGE1)
  const [quoteUserReg, setQuoteUserReg] = useState<QuoteServicesProps>()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <Modal
        active={openModal.label === ModalEnum.CHANGE_POLICY && openModal.isOpen}
        hideModal={() => {
          setOpenModal({ label: '', isOpen: false })
        }}
        onAccept={() => {
          setOpenModal({ label: '', isOpen: false })
        }}
        title=""
        description={''}
        isForm={true}
        acceptText={''}
        style={{ maxWidth: '650px' }}
        isFooterHidden={true}
        children={
          <>
            {stage === Stages.STAGE1 && (
              <PolicyPlanSelection planId={planId} setOpenModal={setOpenModal} setQuoteUserReg={setQuoteUserReg} quoteUserReg={quoteUserReg} setStage={setStage} />
            )}

            {stage === Stages.STAGE2 && <ServicesForm setOpenModal={setOpenModal} setQuoteUserReg={setQuoteUserReg} quoteUserReg={quoteUserReg} setStage={setStage} />}
            {stage === Stages.STAGE3 && <PolicyCoveragePlan setOpenModal={setOpenModal} setQuoteUserReg={setQuoteUserReg} quoteUserReg={quoteUserReg} setStage={setStage} />}
            {stage === Stages.STAGE4 && <UserAnnualRevenue setQuoteUserReg={setQuoteUserReg} setOpenModal={setOpenModal} setStage={setStage} quoteUserReg={quoteUserReg} />}
            {stage === Stages.STAGE5 && <PolicyQuoteReview setQuoteUserReg={setQuoteUserReg} setOpenModal={setOpenModal} setStage={setStage} quoteUserReg={quoteUserReg} />}
            {stage === Stages.STAGE6 && (
              <StripeComponent
                WrappedComponent={() => (
                  <ChangePolicyPayment
                    setStage={setStage}
                    setQuoteUserReg={setQuoteUserReg}
                    setOpenModal={setOpenModal}
                    setNotification={setNotification}
                    quoteUserReg={quoteUserReg}
                  />
                )}
              />
            )}
          </>
        }
      />
    </>
  )
}

export default ChangePolicy
